import React, { useRef } from "react";
import Sketch from "react-p5";
import { useReactToPrint } from "react-to-print";
import { wall } from "./entities/wall";
import { door } from "./entities/door";
import { title } from "./entities/title";
import { window1 } from "./entities/window1";
import { window2 } from "./entities/window2";
import { frenchDoorL, frenchDoorR, frenchDoorC } from "./entities/frenchDoors";
import { clicked } from "./entities/clicked";
import Timing from "./entities/Timing";
import styled from "styled-components";
import { useFirestore } from "react-redux-firebase";

const Container = styled.div`
  position: relative;
`;

const PrintButton = styled.div`
  position: absolute;
  right: 0;
  z-index: 999;
  cursor: pointer;
  padding: 20px;
  border: 1px solid transparent;
  &:hover {
    color: black;
    border: 1px solid black;
  }
  display: none;
  @media screen and (min-width: 900px) {
    display: block;
  }
`;

export const CanvasToPrint = ({ trait, yurtTrait, setWalls, walls }) => {
  const firestore = useFirestore();

  const setWindowInstall = (window) => {
    let newWallArr = [...walls];

    !newWallArr[trait.id][window].installment
      ? (newWallArr[trait.id][window].installment = "arrived")
      : newWallArr[trait.id][window].installment === "arrived"
      ? (newWallArr[trait.id][window].installment = "installed")
      : (newWallArr[trait.id][window].installment = false);

    setWalls(newWallArr);

    let updateProject = yurtTrait;
    updateProject.walls = newWallArr;

    return firestore.update(
      { collection: "projects", doc: yurtTrait.id },
      updateProject
    );
  };

  const setup = (p5) => {
    var canvasDiv = document.getElementById("main-canvas");
    var width = canvasDiv.offsetWidth;
    var sketch = p5.createCanvas(width, trait.h + 100);
    sketch.parent("main-canvas");
  };

  let window1Placement = { x: 0, y: 0 };
  let window2Placement = { x: 0, y: 0 };

  const draw = (p5) => {
    p5.background(255);
    var canvasDiv = document.getElementById("main-canvas");
    var width = canvasDiv.offsetWidth;
    p5.resizeCanvas(width, yurtTrait.h + 150);
    if (trait.frenchDoor === "left") {
      frenchDoorL(p5, trait, width, yurtTrait);
    } else if (trait.frenchDoor === "center") {
      frenchDoorC(p5, trait, width, yurtTrait);
    } else if (trait.frenchDoor === "right") {
      frenchDoorR(p5, trait, width, yurtTrait);
    } else {
      wall(p5, trait, width, yurtTrait);
    }

    if (trait.doors) {
      door(p5, trait, width, yurtTrait);
    }

    if (trait.windows === 1) {
      window1Placement = window1(p5, trait, width, yurtTrait);
    } else if (trait.windows === 2) {
      window1(p5, trait, width, yurtTrait);
      window2Placement = window2(p5, trait, width, yurtTrait);
      window1Placement = window1(p5, trait, width, yurtTrait);
    }

    title(p5, trait, width, yurtTrait);

    // p5.mouseClicked = () => {
    //   clicked(
    //     p5,
    //     trait,
    //     width,
    //     yurtTrait,
    //     window1Placement,
    //     window2Placement,
    //     setWindowInstall
    //   );
    // };
  };
  return (
    <div id="main-canvas" style={{ paddingTop: "40px" }}>
      <Sketch setup={setup} draw={draw} />
      <Timing trait={trait} />
    </div>
  );
};

const Canvas = ({ trait, yurtTrait, setWalls, walls }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <Container>
      <PrintButton onClick={handlePrint}>Print</PrintButton>

      <div ref={componentRef} className="canvas-container">
        <CanvasToPrint
          trait={trait}
          yurtTrait={yurtTrait}
          walls={walls}
          setWalls={setWalls}
        />
      </div>
    </Container>
  );
};

export default Canvas;
